import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Get configuration from data attributes
    this.mediaId = this.data.get('media-id') || 'u3dwir2188'
    this.playIcon = this.data.get('play-icon') || 'black-right-pointing-iscoceles-right-triangle'
    this.pauseIcon = this.data.get('pause-icon') || 'black-double-vertical-bars'
    
    this.video = null
    this.isPlaying = false
    
    this.initializeWistiaVideo()
  }

  initializeWistiaVideo() {
    if (typeof window.Wistia === 'undefined') {
      setTimeout(() => this.initializeWistiaVideo(), 100)
      return
    }

    this.video = window.Wistia.api(this.mediaId)
    
    if (!this.video) {
      setTimeout(() => this.initializeWistiaVideo(), 100)
      return
    }

    // Set up event listeners for video state changes
    this.video.bind('play', () => {
      this.isPlaying = true
      this.updateButtonState()
    })

    this.video.bind('pause', () => {
      this.isPlaying = false
      this.updateButtonState()
    })

    this.video.bind('end', () => {
      this.isPlaying = false
      this.updateButtonState()
    })

    this.updateButtonState()
  }

  togglePlayPause() {
    if (!this.video) return

    if (this.isPlaying) {
      this.video.pause()
    } else {
      this.video.play()
    }
  }

  updateButtonState() {
    const iconElement = this.element.querySelector('sl-icon')
    if (!iconElement) return
    
    if (this.isPlaying) {
      iconElement.setAttribute('name', this.pauseIcon)
      this.element.setAttribute('aria-label', 'Pause video')
    } else {
      iconElement.setAttribute('name', this.playIcon)
      this.element.setAttribute('aria-label', 'Play video')
    }
  }

  disconnect() {
    if (this.video) {
      this.video.unbind('play')
      this.video.unbind('pause')
      this.video.unbind('end')
    }
  }
}